// iluminacao.jsx
// Configuração centralizada dos circuitos de iluminação


export const GruposPaginas = [
  // Terreo
  ["grupo01", "grupo02", "grupo03", "grupo04", "grupo05", "grupo06", "grupo07", "grupo08","grupo15", "grupo16"],

  // Intermediario
  [ "grupo17", "grupo18", "grupo19", "grupo20", "grupo21", "grupo22", "grupo23", "grupo24", "grupo25","grupo26", "grupo27", "grupo28", "grupo29", 
    "grupo30", "grupo31", "grupo32", "grupo33", "grupo34", "grupo35", "grupo36", "grupo37", "grupo38", "grupo39", 
    "grupo40", "grupo41", "grupo42", "grupo43", "grupo44", "grupo45", "grupo46",  "grupo47", "grupo48", "grupo49", 
    "grupo50", "grupo51", "grupo52", "grupo53", "grupo54", "grupo55", "grupo56", "grupo57", "grupo58", "grupo59",
    "grupo60", "grupo61", "grupo62", "grupo63", "grupo64"],
  // Fachada  
  [ "grupo09", "grupo10", "grupo11", "grupo12", "grupo13", "grupo14"]
]

export const iluminacaoConfig = [
  {
    id: "grupo01",
    modulo: "1",
    idx: "1",
    descricao: "Circuito 01",
    lightType: "normal",
    instances: [
      { x: 26, y: 46, width: 2.5, height: 5, circleNumber: 1 },
      { x: 32.5, y: 37, width: 2.5, height: 5, circleNumber: 1 },
      { x: 31, y: 55.5, width: 2.5, height: 5, circleNumber: 1 }
    ]
  },
  {
    id: "grupo02",
    modulo: "1",
    idx: "2",
    descricao: "Circuito 02",
    lightType: "normal",
    instances: [
      { x: 11, y: 18, width: 2.5, height: 5, circleNumber: 2 },
      { x: 16, y: 18, width: 2.5, height: 5, circleNumber: 2 },
      { x: 11, y: 33, width: 2.5, height: 5, circleNumber: 2 },
      { x: 16, y: 33, width: 2.5, height: 5, circleNumber: 2 },
      { x: 11, y: 52, width: 2.5, height: 5, circleNumber: 2 },
      { x: 11, y: 64, width: 2.5, height: 5, circleNumber: 2 },
      { x: 13, y: 74, width: 2.5, height: 5, circleNumber: 2 }
    ]
  },
  {
    id: "grupo03",
    modulo: "1",
    idx: "3",
    descricao: "Circuito 03",
    lightType: "normal",
    instances: [
      { x: 22, y: 47, width: 2.5, height: 5, circleNumber: 3 }
    ]
  },
  {
    id: "grupo04",
    modulo: "1",
    idx: "4",
    descricao: "Circuito 04",
    lightType: "normal",
    instances: [
      { x: 13.5, y: 25, width: 2.5, height: 5, circleNumber: 4 }
    ]
  },
  {
    id: "grupo05",
    modulo: "2",
    idx: "1",
    descricao: "Circuito 05",
    lightType: "normal",
    instances: [
      { x: 17.6, y: 64, width: 2.5, height: 5, circleNumber: 5 }
    ]
  },
  {
    id: "grupo06",
    modulo: "2",
    idx: "2",
    descricao: "Circuito 06",
    lightType: "normal",
    instances: [
      { x: 22.5, y: 35, width: 2.5, height: 5, circleNumber: 6 }
    ]
  },
  {
    id: "grupo07",
    modulo: "2",
    idx: "3",
    descricao: "Circuito 07",
    lightType: "normal",
    instances: [
      { x: 20, y: 35, width: 2.5, height: 5, circleNumber: 7 }
    ]
  },
  {
    id: "grupo08",
    modulo: "2",
    idx: "4",
    descricao: "Circuito 08",
    lightType: "normal",
    instances: [
      { x: 19.7, y: 53, width: 2.5, height: 5, circleNumber: 8 }
    ]
  },
  {
    id: "grupo09",
    modulo: "3",
    idx: "1",
    descricao: "Led frente inferior",
    lightType: "mixed",
    instances: [
      { x: 64, y: 71, width: 2.5, height: 5, circleNumber: 9 },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.96 89.12 L 63.09 89.78", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.72 85.48 L 63.17 86.64", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.72 77.72 L 63.17 79.86", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.96 74.41 L 63.01 76.56", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.88 66.98 L 63.25 69.62", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.80 63.51 L 63.25 66.31", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 57 56 L 63.42 59.87", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.96 52.43 L 63.33 56.57", ledColor: "#FFA500", ledMode: "static" }
    ]
  },
  {
    id: "grupo10",
    modulo: "3",
    idx: "2",
    descricao: "Led frente intermediário",
    lightType: "mixed",
    instances: [
      { x: 64, y: 40, width: 2.5, height: 5, circleNumber: 10 },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.88 44.67 L 63.09 49.63", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.96 41.03 L 63.01 46.16", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.72 33.76 L 63.09 39.22", ledColor: "#FFA500", ledMode: "static" },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 56.80 29.96 L 63.09 36.24", ledColor: "#FFA500", ledMode: "static" }
    ]
  },
  {
    id: "grupo11",
    modulo: "3",
    idx: "3",
    descricao: "Led frente Superior",
    lightType: "mixed",
    instances: [
      { x: 64, y: 25, width: 2.5, height: 5, circleNumber: 11 },
      { x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 46.91 9.80 L 63.09 28.81", ledColor: "#FFA500", ledMode: "static" }
    ]
  },
  {
    id: "grupo12",
    modulo: "3",
    idx: "4",
    descricao: "Led trás inferior",
    lightType: "mixed",
    instances: [
      { x: 35, y: 71, width: 2.5, height: 5, circleNumber: 12 }
    ]
  },
  {
    id: "grupo13",
    modulo: "4",
    idx: "1",
    descricao: "Led trás intermediário",
    lightType: "mixed",
    instances: [
      { x: 35, y: 40, width: 2.5, height: 5, circleNumber: 13 }
    ]
  },
  {
    id: "grupo14",
    modulo: "4",
    idx: "2",
    descricao: "Led trás Superior",
    lightType: "mixed",
    instances: [
      { x: 35, y: 25, width: 2.5, height: 5, circleNumber: 14 }
    ]
  },
  {
    id: "grupo15",
    modulo: "4",
    idx: "3",
    descricao: "Circuito 15",
    lightType: "normal",
    instances: [
          { x: 33.5, y: 25, width: 2.5, height: 5, circleNumber: 15 },
          { x: 45, y: 25, width: 2.5, height: 5, circleNumber: 15 },
          { x: 65, y: 25, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 25, width: 2.5, height: 5, circleNumber: 15 },
          { x: 79.5, y: 19, width: 2.5, height: 5, circleNumber: 15 },
          { x: 89.5, y: 19, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 2
          { x: 27.5, y: 33, width: 2.5, height: 5, circleNumber: 15 },
          { x: 41.5, y: 33, width: 2.5, height: 5, circleNumber: 15 },
          { x: 45.5, y: 40, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 33, width: 2.5, height: 5, circleNumber: 15 },
          { x: 60, y: 33, width: 2.5, height: 5, circleNumber: 15 },
          { x: 65.5, y: 39, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 40, width: 2.5, height: 5, circleNumber: 15 },
          { x: 79.5, y: 33, width: 2.5, height: 5, circleNumber: 15 },
          { x: 89.5, y: 33, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 3 (centro)
          { x: 41.5, y: 60, width: 2.5, height: 5, circleNumber: 15 },
          { x: 45.5, y: 54, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 48, width: 2.5, height: 5, circleNumber: 15 },
          { x: 60, y: 48, width: 2.5, height: 5, circleNumber: 15 },
          { x: 64.5, y: 53, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 53, width: 2.5, height: 5, circleNumber: 15 },
          { x: 79.5, y: 46, width: 2.5, height: 5, circleNumber: 15 },
          { x: 89.5, y: 48, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 4
          { x: 27, y: 68, width: 2.5, height: 5, circleNumber: 15 },
          { x: 46, y: 68, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 62, width: 2.5, height: 5, circleNumber: 15 },
          { x: 60, y: 62, width: 2.5, height: 5, circleNumber: 15 },
          { x: 65, y: 68, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 68, width: 2.5, height: 5, circleNumber: 15 },
          { x: 79.5, y: 61, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 5 (sul)
          { x: 79.5, y: 75, width: 2.5, height: 5, circleNumber: 15 },
          { x: 89.5, y: 75, width: 2.5, height: 5, circleNumber: 15 },
          { x: 89.5, y: 61, width: 2.5, height: 5, circleNumber: 15 },
          

    ]
  },
  {
    id: "grupo16",
    modulo: "4",
    idx: "4",
    descricao: "Circuito 16",
    lightType: "normal",
    instances: [
      { x: 31.5, y: 47.5, width: 2.5, height: 5, circleNumber: 16 }
    ]
  },
  {
    id: "grupo17",
    modulo: "5",
    idx: "1",
    descricao: "Circuito 17",
    lightType: "normal",
    instances: [
      { x: 40, y: 16, width: 2.5, height: 5, circleNumber: 17 }
    ]
  },
  {
    id: "grupo18",
    modulo: "5",
    idx: "2",
    descricao: "Circuito 18",
    lightType: "normal",
    instances: [
      { x: 32, y: 62, width: 2.5, height: 5, circleNumber: 18 }
    ]
  },
  {
    id: "grupo19",
    modulo: "5",
    idx: "3",
    descricao: "Circuito 19",
    lightType: "normal",
    instances: [
      { x: 16, y: 62, width: 2.5, height: 5, circleNumber: 19 }
    ]
  },
  {
    id: "grupo20",
    modulo: "5",
    idx: "4",
    descricao: "Circuito 20",
    lightType: "normal",
    instances: [
      { x: 7.5, y: 58, width: 2.5, height: 5, circleNumber: 20 }
    ]
  },
  {
    id: "grupo21",
    modulo: "6",
    idx: "1",
    descricao: "Circuito 21",
    lightType: "normal",
    instances: [
      { x: 19.5, y: 46.5, width: 2.5, height: 5, circleNumber: 21 }
    ]
  },
  {
    id: "grupo22",
    modulo: "6",
    idx: "2",
    descricao: "Circuito 22",
    lightType: "normal",
    instances: [
      { x: 35, y: 38, width: 2.5, height: 5, circleNumber: 22 }
    ]
  },
  {
    id: "grupo23",
    modulo: "6",
    idx: "3",
    descricao: "Circuito 23",
    lightType: "normal",
    instances: [
      { x: 32.5, y: 23, width: 2.5, height: 5, circleNumber: 23 }
    ]
  },
  {
    id: "grupo24",
    modulo: "6",
    idx: "4",
    descricao: "Circuito 24",
    lightType: "normal",
    instances: [
      { x: 8, y: 73, width: 2.5, height: 5, circleNumber: 24 }
    ]
  },
  {
    id: "grupo25",
    modulo: "7",
    idx: "1",
    descricao: "Circuito 25",
    lightType: "normal",
    instances: [
      { x: 12, y: 46, width: 2.5, height: 5, circleNumber: 25 }
    ]
  },
  {
    id: "grupo26",
    modulo: "7",
    idx: "2",
    descricao: "Circuito 26",
    lightType: "normal",
    instances: [
      { x: 12.3, y: 34, width: 2.5, height: 5, circleNumber: 26 }
    ]
  },
  {
    id: "grupo27",
    modulo: "7",
    idx: "3",
    descricao: "Circuito 27",
    lightType: "normal",
    instances: [
      { x: 15.2, y: 46, width: 2.5, height: 5, circleNumber: 27 }
    ]
  },
  {
    id: "grupo28",
    modulo: "7",
    idx: "4",
    descricao: "Circuito 28",
    lightType: "normal",
    instances: [
      { x: 28, y: 30, width: 2.5, height: 5, circleNumber: 28 },
      { x: 16.5, y: 30, width: 2.5, height: 5, circleNumber: 28 }
    ]
  },
  {
    id: "grupo29",
    modulo: "8",
    idx: "1",
    descricao: "Circuito 29",
    lightType: "normal",
    instances: [
      { x: 13, y: 20, width: 2.5, height: 5, circleNumber: 29 },
      { x: 25, y: 20, width: 2.5, height: 5, circleNumber: 29 }
    ]
  },
  {
    id: "grupo30",
    modulo: "8",
    idx: "2",
    descricao: "Circuito 30",
    lightType: "normal",
    instances: [
      { x: 28, y: 23, width: 2.5, height: 5, circleNumber: 30 }
    ]
  },
  {
    id: "grupo31",
    modulo: "8",
    idx: "3",
    descricao: "Circuito 31",
    lightType: "normal",
    instances: [
      { x: 37.5, y: 76.5, width: 2.5, height: 5, circleNumber: 31 }
    ]
  },
  {
    id: "grupo32",
    modulo: "8",
    idx: "4",
    descricao: "Circuito 32",
    lightType: "normal",
    instances: [
      { x: 29, y: 41, width: 2.5, height: 5, circleNumber: 32 }
    ]
  },
  {
    id: "grupo33",
    modulo: "9",
    idx: "1",
    descricao: "Circuito 33",
    lightType: "normal",
    instances: [
      { x: 95, y: 11.5, width: 2.5, height: 5, circleNumber: 33 }
    ]
  },
  {
    id: "grupo34",
    modulo: "9",
    idx: "2",
    descricao: "Circuito 34",
    lightType: "normal",
    instances: [
      { x: 74, y: 13, width: 2.5, height: 5, circleNumber: 34 }
    ]
  },
  {
    id: "grupo35",
    modulo: "9",
    idx: "3",
    descricao: "Circuito 35",
    lightType: "normal",
    instances: [
      { x: 5000, y: 0, width: 2.5, height: 5, circleNumber: 35 }
    ]
  },
  {
    id: "grupo36",
    modulo: "9",
    idx: "4",
    descricao: "Circuito 36",
    lightType: "normal",
    instances: [
      { x: 71, y: 29, width: 2.5, height: 5, circleNumber: 36 }
    ]
  },
  {
    id: "grupo37",
    modulo: "10",
    idx: "1",
    descricao: "Circuito 37",
    lightType: "normal",
    instances: [
      { x: 87, y: 10, width: 2.5, height: 5, circleNumber: 37 }
    ]
  },
  {
    id: "grupo38",
    modulo: "10",
    idx: "2",
    descricao: "Circuito 38",
    lightType: "normal",
    instances: [
      { x: 40, y: 71, width: 2.5, height: 5, circleNumber: 38 }
    ]
  },
  {
    id: "grupo39",
    modulo: "10",
    idx: "3",
    descricao: "Circuito 39",
    lightType: "normal",
    instances: [
      { x: 63.5, y: 51, width: 2.5, height: 5, circleNumber: 39 }
    ]
  },
  {
    id: "grupo40",
    modulo: "10",
    idx: "4",
    descricao: "Circuito 40",
    lightType: "normal",
    instances: [
      { x: 50, y: 72, width: 2.5, height: 5, circleNumber: 40 }
    ]
  },
  {
    id: "grupo41",
    modulo: "11",
    idx: "1",
    descricao: "Circuito 41",
    lightType: "normal",
    instances: [
      { x: 62, y: 75, width: 2.5, height: 5, circleNumber: 41 }
    ]
  },
  {
    id: "grupo42",
    modulo: "11",
    idx: "2",
    descricao: "Circuito 42",
    lightType: "normal",
    instances: [
      { x: 57.5, y: 59, width: 2.5, height: 5, circleNumber: 42 }
    ]
  },
  {
    id: "grupo43",
    modulo: "11",
    idx: "3",
    descricao: "Circuito 43",
    lightType: "normal",
    instances: [
      { x: 60, y: 67.5, width: 2.5, height: 5, circleNumber: 43 }
    ]
  },
  {
    id: "grupo44",
    modulo: "11",
    idx: "4",
    descricao: "Circuito 44",
    lightType: "normal",
    instances: [
      { x: 45, y: 56, width: 2.5, height: 5, circleNumber: 44 },
      { x: 52, y: 51, width: 2.5, height: 5, circleNumber: 44 }
    ]
  },
  {
    id: "grupo45",
    modulo: "12",
    idx: "1",
    descricao: "Circuito 45",
    lightType: "normal",
    instances: [
      { x: 47, y: 47, width: 2.5, height: 5, circleNumber: 45 }
    ]
  },
  {
    id: "grupo46",
    modulo: "12",
    idx: "2",
    descricao: "Circuito 46",
    lightType: "normal",
    instances: [
      { x: 55, y: 35, width: 2.5, height: 5, circleNumber: 46 },
      { x: 60.5, y: 34, width: 2.5, height: 5, circleNumber: 46 }
    ]
  },
  {
    id: "grupo47",
    modulo: "12",
    idx: "3",
    descricao: "Circuito 47",
    lightType: "normal",
    instances: [
      { x: 67, y: 29.5, width: 2.5, height: 5, circleNumber: 47 }
    ]
  },
  {
    id: "grupo48",
    modulo: "12",
    idx: "4",
    descricao: "Circuito 48",
    lightType: "normal",
    instances: [
      { x: 45, y: 25, width: 2.5, height: 5, circleNumber: 48 },
      { x: 56, y: 17, width: 2.5, height: 5, circleNumber: 48 }
    ]
  },
  {
    id: "grupo49",
    modulo: "13",
    idx: "1",
    descricao: "Circuito 49",
    lightType: "normal",
    instances: [
      { x: 95.5, y: 60, width: 2.5, height: 5, circleNumber: 49 }
    ]
  },
  {
    id: "grupo50",
    modulo: "13",
    idx: "2",
    descricao: "Circuito 50",
    lightType: "normal",
    instances: [
      { x: 93.5, y: 25, width: 2.5, height: 5, circleNumber: 50 }
    ]
  },
  {
    id: "grupo51",
    modulo: "13",
    idx: "3",
    descricao: "Circuito 51",
    lightType: "normal",
    instances: [
      { x: 92, y: 30, width: 2.5, height: 5, circleNumber: 51 }
    ]
  },
  {
    id: "grupo52",
    modulo: "13",
    idx: "4",
    descricao: "Circuito 52",
    lightType: "normal",
    instances: [
      { x: 90.5, y: 65, width: 2.5, height: 5, circleNumber: 52 }
    ]
  },
  {
    id: "grupo53",
    modulo: "14",
    idx: "1",
    descricao: "Circuito 53",
    lightType: "normal",
    instances: [
      { x: 90, y: 87, width: 2.5, height: 5, circleNumber: 53 }
    ]
  },
  {
    id: "grupo54",
    modulo: "14",
    idx: "2",
    descricao: "Circuito 54",
    lightType: "normal",
    instances: [
      { x: 78.5, y: 87, width: 2.5, height: 5, circleNumber: 54 },
      { x: 88.5, y: 72, width: 2.5, height: 5, circleNumber: 54 }
    ]
  },
  {
    id: "grupo55",
    modulo: "14",
    idx: "3",
    descricao: "Circuito 55",
    lightType: "normal",
    instances: [
      { x: 82.5, y: 83, width: 2.5, height: 5, circleNumber: 55 },
      { x: 73.5, y: 83, width: 2.5, height: 5, circleNumber: 55 }
    ]
  },
  {
    id: "grupo56",
    modulo: "14",
    idx: "4",
    descricao: "Circuito 56",
    lightType: "normal",
    instances: [
      { x: 92.5, y: 49, width: 2.5, height: 5, circleNumber: 56 }
    ]
  },
  {
    id: "grupo57",
    modulo: "15",
    idx: "1",
    descricao: "Circuito 57",
    lightType: "normal",
    instances: [
      { x: 61, y: 42, width: 2.5, height: 5, circleNumber: 57 }
    ]
  },
  {
    id: "grupo58",
    modulo: "15",
    idx: "2",
    descricao: "Circuito 58",
    lightType: "normal",
    instances: [
      { x: 90, y: 35, width: 2.5, height: 5, circleNumber: 58 }
    ]
  },
  {
    id: "grupo59",
    modulo: "15",
    idx: "3",
    descricao: "Circuito 59",
    lightType: "normal",
    instances: [
      { x: 74, y: 32, width: 2.5, height: 5, circleNumber: 59 },
      { x: 79, y: 25, width: 2.5, height: 5, circleNumber: 59 }
    ]
  },
  {
    id: "grupo60",
    modulo: "15",
    idx: "4",
    descricao: "Circuito 60",
    lightType: "normal",
    instances: [
      { x: 92, y: 76, width: 2.5, height: 5, circleNumber: 60 }
    ]
  },
  {
    id: "grupo61",
    modulo: "16",
    idx: "1",
    descricao: "Circuito 61",
    lightType: "normal",
    instances: [
      { x: 78.5, y: 52, width: 2.5, height: 5, circleNumber: 61 }
    ]
  },
  {
    id: "grupo62",
    modulo: "16",
    idx: "2",
    descricao: "Circuito 62",
    lightType: "normal",
    instances: [
      { x: 89.5, y: 55, width: 2.5, height: 5, circleNumber: 62 }
    ]
  },
  {
    id: "grupo63",
    modulo: "16",
    idx: "3",
    descricao: "Circuito 63",
    lightType: "normal",
    instances: [
      { x: 77, y: 32, width: 2.5, height: 5, circleNumber: 63 }
    ]
  },
  {
    id: "grupo64",
    modulo: "16",
    idx: "4",
    descricao: "Circuito 64",
    lightType: "normal",
    instances: [
      { x: 75, y: 66, width: 2.5, height: 5, circleNumber: 64 },
      { x: 81, y: 73, width: 2.5, height: 5, circleNumber: 64 }
    ]
  }
];

// Função útil para obter informações de ON/OFF para cada circuito
export const getCircuitOnOffValues = (circuitNumber) => {
  const circuitIndex = circuitNumber - 1;
  if (circuitIndex < 0 || circuitIndex >= iluminacaoConfig.length) {
    return null;
  }
  
  const circuit = iluminacaoConfig[circuitIndex];
  return {
    descricao: circuit.descricao,
    onValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "OFF" })
  };
};